import { useState } from 'react';

const AuthModal = ({ isOpen, onClose, initialMode }) => {
  const [mode, setMode] = useState(initialMode);

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.7)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex: 2000
    }}>
      <div style={{
        background: 'white', padding: '40px', borderRadius: '12px',
        width: '100%', maxWidth: '400px'
      }}>
        <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>
          {mode === 'signin' && 'Sign In'}
          {mode === 'signup' && 'Create Account'}
          {mode === 'forgot' && 'Reset Password'}
        </h2>

        <button onClick={onClose} style={{ position: 'absolute', top: '20px', right: '20px', fontSize: '24px' }}>
          ×
        </button>

        {/* Simple Form - You can expand later */}
        <p style={{ textAlign: 'center', marginTop: '30px' }}>
          {mode === 'signin' ? "Backend connection coming soon" : "Registration form coming soon"}
        </p>
      </div>
    </div>
  );
};

export default AuthModal;